import CotationCard from "./CotationCard";
import AssignmentIcon from "@/assets/icons/assignement.svg?react";
import StyledSwitch from "@/components/ui/customs/StyledSwitch";
import { useFormContext } from "react-hook-form";
import { CotationFormData } from "@/types/forms/home/cotationFormData.form";
import { useGetCompany } from "@/api/company.api";
import { GetCustomV1Response } from "@/types/api/api-types";

type DapOptionCardProps = {
  selectedCustom?: GetCustomV1Response;
};

const DapOptionCard = ({ selectedCustom }: DapOptionCardProps) => {
  const { control } = useFormContext<CotationFormData>();
  const { data: company, isSuccess } = useGetCompany();

  if (
    isSuccess &&
    company.optionDAPActive &&
    !selectedCustom?.recipientChargeTaxes &&
    !selectedCustom?.label.includes("DDP")
  ) {
    return (
      <CotationCard>
        <div className="flex flex-1 flex-row gap-4">
          <AssignmentIcon className="text-zinc-900" />
          <div className="flex flex-1 flex-col">
            <p className="font-semibold">Option DAP</p>
            <p>
              {
                "En choisissant cette option le client devra payer les taxes à l'arrivée de son colis"
              }
            </p>
          </div>
          <StyledSwitch name="dapOption" control={control} />
        </div>
      </CotationCard>
    );
  }

  return null;
};

export default DapOptionCard;
